import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Header from '@components/Header';
import Footer from '@components/Footer';
import LandingIntroduction from '@components/LandingIntroduction';
import SubFeatures from '@components/SubFeatures';
import PlanBanner from '@components/PlanBanner';
import AffiliateContent from '@components/AffiliateContent';
import AffiliateOnBoardSteps from '@components/AffiliateOnBoardSteps';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import LazyLoad from 'react-lazyload';

const useStyles = makeStyles(theme => ({
  root: {
    overflow: 'hidden',
    paddingTop: 58,
  },
}));

let features = [];
for (let i = 1; i <= 4; i++) {
  features.push({
    image: `/static/images/affiliate-subfeature-${i}.svg`,
    heading: `affiliate-subfeature-${i}`,
  });
}

const Index = ({ locale }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Header />
      <LandingIntroduction
        heading="affiliate-introduction-heading"
        subHeading="affiliate-introduction-desc"
        ctaLabel="affiliate-introduction-register-btn"
        align="left"
        desktopBgImage="/static/images/affiliate-landing-image.jpg"
        mobileBgImage="/static/images/affiliate-landing-image-mobile.jpg"
        url="https://api.whatsapp.com/send/?phone=60162433083&text=你好，想洽谈成为代理的详情。"
      />
      <AffiliateContent />
      <SubFeatures
        alignItems="center"
        heading="affiliate-subfeatures-heading"
        features={features}
      />
      <AffiliateOnBoardSteps locale={locale} />
      <LazyLoad>
        <PlanBanner
          heading="affiliate-plan-banner-heading"
          description="affiliate-plan-banner-desc"
          remarks="affiliate-plan-banner-remarks"
          desktopBgImage="/static/images/affiliate-plan.jpg"
          mobileBgImage="/static/images/affiliate-plan-mobile.jpg"
          url="https://api.whatsapp.com/send/?phone=60162433083&text=你好，想洽谈成为代理的详情。"
        />
      </LazyLoad>
      <Footer />
    </div>
  );
};

export const getServerSideProps = async ({ locale }) => {
  return {
    props: {
      locale,
      ...(await serverSideTranslations(locale, ['common'])),
    },
  };
};
export default Index;
